/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import ko from "knockout";
import birdata from "../api.js";
import _ from "underscore";

var DeleteAccountViewModel = function(params) {
	var self = this;

	self.state = ko.observable('loading'); // 'idle', 'submitting'
	self.error = ko.observable();
	self.comments = ko.observable('');
	self.user = ko.observable();
	self.userStats = ko.observable();

	var data = {
		userAgent: navigator.userAgent,
		url: document.location.href,
		screen: _.pick(screen, 'width', 'height')
	};

	Promise.all([birdata.me(true), birdata.myStats()]).then(function([me, stats]) {
		self.user(me);
		self.userStats(stats);
		self.state('idle');
		data.user = me;
	});

	self.send = function() {
		self.state('submitting');
		birdata.submitFeedback({
			type: 'delete-account-request',
			message: self.comments(),
			user_email: self.user().email,
			user_info: data
		}).then(function() {
			self.state('success');
		}).catch(function(e) {
			self.error("There was a problem submitting your request. Please contact birdata@birdlife.org.au.")
			self.state('idle');
			throw e;
		});
	};
};

ko.components.register('delete-account', {
	viewModel: function(params) {
		return new DeleteAccountViewModel(params);
	},
	template: require('../../templates/delete-account.html')
});

export default DeleteAccountViewModel;
